/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-17 14:35:05
 * @modify date 2020-04-17 14:35:05
 * @desc [description]
 */
import axios from 'axios';

/**
 * exportToPDF post api
 * to export the pdf using api call */
export async function exportToPDF(chartObj) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/export_pdf`, chartObj)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('export_pdf python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * exportToExcel post api
 * to export the excel using api call */
export async function exportToExcel(exportOption, chartObj) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/export_to_excel/${exportOption}`, chartObj)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('export_to_excel python api error', err); // eslint-disable-line no-console
    });
  return result;
}
